import React, { useCallback, useEffect, useState } from "react";
import { Select, MenuItem } from "@material-ui/core";
import axios from "axios";

const { REACT_APP_MY_ENV } = process.env;
const apiInternal = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

function SelectWithAPI(props) {
  const [selectOptions, setSelectOptions] = useState([]);
  /* 
  componentDidMount() {
    this.getOptions();
  } */
  const getOptions = useCallback(async () => {
    const res = await apiInternal({
      method: "get",
      url: props.url,
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    });
    const data = res.data;
    ////console.log("DATA", data);
    let menuItems = null;

    if (props.idValue != null) {
      ////console.log(props.idValue);
      menuItems = data.map((d) => (
        <MenuItem
          key={d.id}
          value={d.id}
          primarytext={d.name}
          selected={d.id === props.idValue}
        >
          {d.name}
        </MenuItem>
      ));
    } else {
      menuItems = data.map((d) => (
        <MenuItem key={d.id} value={d.id} primarytext={d.name} selected={false}>
          {d.name}
        </MenuItem>
      ));
    }

    setSelectOptions(menuItems);
    //this.setState({ selectOptions: menuItems });
    ////console.log("SelectOptions", menuItems);
  }, [props.idValue, props.url]);

  useEffect(() => {
    getOptions();
  }, [getOptions, props.condit]);

  ////console.log(props.condit);

  return (
    <Select
      id={props.id}
      name={props.name}
      labelId={props.labelid}
      label={props.label}
      disabled={props.disabled}
      style={props.style}
      variant="outlined"
      fullWidth
      onChange={props.onChange}
      value={props.value}
      required={props.required}
    >
      {selectOptions}
    </Select>
  );
}

export default SelectWithAPI;
